import validate from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.0.8_@vue+compiler-sfc@3.5.26_cac@6.7.1_ca18fcc40b094d04ab0d3300b203aa31/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/app/middleware/router.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.0.8_@vue+compiler-sfc@3.5.26_cac@6.7.1_ca18fcc40b094d04ab0d3300b203aa31/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}